<template>
    <div id="app">
        <!-- <router-view /> -->
         <index />
    </div>
</template>

<script>
import { getQueryString } from './utils'
import index from './pages/indexnew';
export default {
    name: 'App',
    components: {index},
    created() {
        
    },
    mounted() {},
    methods: {
         
    }
}
</script>

<style>
#app {
    position: relative;
    left: 0;
    top: 0;
    background-color: #000;
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue